import { AxiosError } from 'axios';
import { t } from '@lingui/macro';
import { Toaster, ToastReference } from '@economic/taco';
import { DimensionDistributionValue } from '~/app/shared/dimensions/types';

export const getDistributionValueFormUtils = (distributions: DimensionDistributionValue[]) => {
    const distributedPercentageSum =
        distributions
            ?.map(({ percent }: DimensionDistributionValue) => percent)
            .reduce((sum, value) => Number(sum ?? 0) + Number(value ?? 0)) ?? 0;

    const dimValueKeys = distributions.map(({ dimensionValueKey }) => dimensionValueKey);
    const dimValueKeysAreUnique = new Set(dimValueKeys).size === dimValueKeys.length;

    return {
        distributedPercentageSum,
        dimValueKeysAreUnique,
    };
};

export const onSubmitError = (err: AxiosError, toast: Toaster<ToastReference>) => {
    if (err.response?.status && err.response.status >= 500) {
        toast.error(t`Something went wrong`, { autoClose: 10000 });
    }
};

export const removalErrorParametersToString = (params: string[]) => {
    if (params.length === 1) {
        return params[0];
    }
    if (params.length > 1) {
        const tmpParams = [...params];
        const lastEntityString = ' '.concat(t` and `, ' ', tmpParams.pop() ?? '');
        const allEntitiesString = tmpParams.join(', ').concat(lastEntityString);
        return allEntitiesString;
    }
    return '';
};
